<template>
  <modal :modal-key="'confirm_challenge_request'" :class-style="'modal--welcomeback modal--zero-balance'"
         :header-style="'request'"
         :body-style="'request_content'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_confirm_challenge_your_challenge_invitation }}</h1>
      <div class="request_user">
        <img :src=avatar alt="">
        <span class="name">{{ username }}</span>
        <span class="level">{{ getTranslations.home_confirm_challenge_level }} {{ level }}</span>
      </div>
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_confirm_challenge_hi }} {{ userDetails.username }} {{
        getTranslations.home_confirm_challenge_ready_to_play }}</p>

      <flickity class="stickers stickers-main" ref="flickity" :options="flickityOptions">
        <div class="stickers-cell"><img class="pinicon" :src="'static/images/chat/chat_icon_' + userChoice + '.svg'" alt=""></div>
      </flickity>

      <flickity class="stickers stickers-nav"
           data-flickity='{ "asNavFor": ".stickers-main", "pageDots": false }'>
        <div class="stickers-cell" v-for="index in 4"
             :key="index"
             :index="index">
          <img class="pinicon" :src="'static/images/chat/chat_icon_' + index + '.svg'" alt="" @click.prevent="checkIcon(index)">
        </div>
      </flickity>

    </template>
    <template slot="footer">
      <a style="cursor:pointer" class="btn2 btn2_modal btn2--std btn2--small" @click.prevent="challenge()">{{
        getTranslations.home_confirm_challenge_send_request }}</a>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Flickity from 'vue-flickity';
import Modal from '@/components/home/modals/shared/GenericModal';
import RequestForRematch from '@/common/mixins/extraRematchInfo';

export default {
  // modal_confirm_challenge_request.html
  name: 'confirm-challenge-request',
  components: {
    Flickity,
    Modal,
  },
  data() {
    return {
      username: null,
      avatar: null,
      level: 0,
      userChoice: 1,
      flickityOptions1: {
        asNavFor: '.stickers-main',
        contain: true,
        pageDots: false,
      },
      flickityOptions: {
        draggable: false,
        prevNextButtons: false,
      },
    };
  },
  mixins: [RequestForRematch],
  created() {
    this.username = this.getSelectedUser.username ? this.getSelectedUser.username : this.challengeInfo.challengedUsername;
    this.avatar = this.getSelectedUser.avatar ? this.getSelectedUser.avatar : this.challengeInfo.challengedAvatar;
    this.level = this.getSelectedUser.level ? this.getSelectedUser.level : this.challengeInfo.challengedLevel;
  },
  methods: {
    checkIcon(keyIndex) {
      this.userChoice = keyIndex;
    },
    challenge() {
      this.requestRematch(this.username, false, this.userChoice, false);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('users', [
      'getSelectedUser',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'challengeInfo',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/ConfirmChallengeRequest.vue